import styled from "styled-components";

const LeftPartImageContainer = styled.div`
  margin-bottom: 30px;
  padding-right: 0.25rem !important;

  @media (max-width: 575px) {
    margin-bottom: 20px;
    width: 50%;
  }
`;
export default LeftPartImageContainer;
